import { PlanSubmissionStatus } from '@ebalance/proto/bfftypes/v1/plan_submission_pb'
import {
  PlanSubmitBlockReason,
  ProcurementPlanSubmitErrorCategory,
} from '@ebalance/proto/bffuser/v1/procurement_plan_model_pb'

import { canSubmit } from '~/pages/ProcurementPlanDetail/models/canSubmit'

/** 版の詳細のテーブル上部に出す AC-PPD-029 の案内。出さない時は undefined。 */
export type NoSubmissionRecordVersionNotice = {
  /** 「この版を提出すると、広域機関の計画が置き換わります。」も続けて出すか */
  showsReplaceNote: boolean
}

/**
 * 版の詳細に AC-PPD-029 の案内を出すか (spec procurement-plan-detail.md AC-PPD-029)。
 *
 * - 案内: 計画が eBalance に提出記録の無い不整合通知 (AC-PSM-078) を表示している間
 *   (`GetPlanCounterpartyMismatchResponse.shows_no_submission_record_notice`)。解消後も出す
 * - 置き換わりの一文: この版を提出できる時だけ。提出を止める理由 (AC-PLC-055 / 056) が
 *   ある版は作り直すまで提出できないので出さない (056 の版は「提出」 を非活性で描画するが、
 *   押せないので置き換わりは起きない)。status が提出できない版 (作成中・承認待ち・
 *   処理中・提出済・受領済・作成失敗) も出さない (`canSubmit`)。
 *   全コマ GC 済みの提出失敗 (AC-PLC-037-2、`errorCategory = GATE_CLOSED_ALL_KOMA`) は
 *   再提出できないので一文を出さない (AC-PPD-029 の品質観点「全コマ GC 済み」)。
 *   未入力コマ・提出中・閲覧のみによる一時的な無効化 (`resolveSubmitAvailability`) は見ない
 *   (置き換わる事実は変わらないため。issue #10266)
 */
export function resolveNoSubmissionRecordVersionNotice(input: {
  showsNoSubmissionRecordNotice: boolean
  status: PlanSubmissionStatus
  submitBlockReason: PlanSubmitBlockReason
  errorCategory: ProcurementPlanSubmitErrorCategory
}): NoSubmissionRecordVersionNotice | undefined {
  if (!input.showsNoSubmissionRecordNotice) return undefined
  const isGateClosedAllKoma =
    input.status === PlanSubmissionStatus.SUBMIT_FAILED &&
    input.errorCategory ===
      ProcurementPlanSubmitErrorCategory.GATE_CLOSED_ALL_KOMA
  return {
    showsReplaceNote:
      canSubmit(input.status) &&
      input.submitBlockReason === PlanSubmitBlockReason.UNSPECIFIED &&
      !isGateClosedAllKoma,
  }
}
